import {
  GetGlobalCategoriesReducer,
  GetGlobalLanguageReducer,
  HttpServices,
} from "../Helpers";
import i18next from "i18next";
import {PHP_V13_URL} from "../api/urls";

export const GetAllJobOpenings = async ({
  company_uuid,
  limit = 10,
  page = 0,
  status = true,
  use_for = "dropdown",
  search,
  skills,
  category,
  job_type,
  major,
  career_level,
  industry,
}) => {
  const queryList = [];
  const language_profile_uuid =
    GetGlobalLanguageReducer() ||
    localStorage.getItem("language_profile_uuid") ||
    "";

  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`itemQuery=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (language_profile_uuid)
    queryList.push(`language_profile_uuid=${language_profile_uuid}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${
      process.env.REACT_APP_VERSION_API
    }/search/jobs?${queryList.join("&")}`,
    {
      headers: {
        ...(company_uuid && {
          "Accept-Company": company_uuid,
        }),
      },
      params: {
        ...(skills?.length > 0 && {skills}),
        ...(category?.length > 0 && {
          category_uuid: category.map((item) => item.uuid),
        }),
        ...(job_type?.length > 0 && {
          job_type: job_type.map(
            (item) => item?.name?.[i18next.language] || item.name.en
          ),
        }),
        ...(major?.length > 0 && {
          major: major.map(
            (item) => item?.name?.[i18next.language] || item.name.en
          ),
        }),
        ...(career_level?.length > 0 && {
          career_level: career_level.map(
            (item) => item?.name?.[i18next.language] || item.name.en
          ),
        }),
        ...(industry?.length > 0 && {
          industry: industry.map(
            (item) => item?.name?.[i18next.language] || item.name.en
          ),
        }),
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const PostEmployeeApplyJob = async (body) => {
  const language_profile_uuid =
    GetGlobalLanguageReducer() ||
    localStorage.getItem("language_profile_uuid") ||
    "";

  const category_uuid =
    GetGlobalCategoriesReducer() ||
    (localStorage.getItem("system_user") &&
      JSON.parse(localStorage.getItem("system_user")).employee_categories) ||
    [];

  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/candidate/ats/apply`,
    {
      ...body,
      language_profile_uuid,
      category_uuid: body.category || category_uuid,
    },
    {
      headers: {
        ...(body.company_uuid && {
          "Accept-Company": body.company_uuid,
        }),
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetCheckCandidate = async ({company_uuid}) => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/candidate/check_candidate`,
    {
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAllSignupValidations = async ({
  job_uuid,
  company_uuid,
  category,
}) => {
  const queryList = [];
  const language_profile_uuid =
    GetGlobalLanguageReducer() ||
    localStorage.getItem("language_profile_uuid") ||
    "";

  const category_uuid =
    category ||
    GetGlobalCategoriesReducer() ||
    (localStorage.getItem("system_user") &&
      JSON.parse(localStorage.getItem("system_user")).employee_categories) ||
    [];

  if (job_uuid) queryList.push(`job_uuid=${job_uuid}`);
  if (language_profile_uuid)
    queryList.push(`language_profile_uuid=${language_profile_uuid}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${
      process.env.REACT_APP_VERSION_API
    }/service/candidate/signup/validations?${queryList.join("&")}`,
    {
      params: {
        category_uuid,
      },
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAppliedJobs = async ({limit = 10, page = 0, search}) => {
  const queryList = [];
  const language_profile_uuid =
    GetGlobalLanguageReducer() ||
    localStorage.getItem("language_profile_uuid") ||
    "";

  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (language_profile_uuid)
    queryList.push(`language_profile_uuid=${language_profile_uuid}`);
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/candidate/${
      process.env.REACT_APP_VERSION_API_V2
    }/ats/employee/my-application?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

// for view (data without uuids)
export const GetEmployeeProfile = async () => {
    const queryList = [];
    const language_profile_uuid = GetGlobalLanguageReducer()
        || localStorage.getItem('language_profile_uuid') || '';

    if (language_profile_uuid) queryList.push(`language_profile_uuid=${language_profile_uuid}`);

    const result = await HttpServices.get(
        `${process.env.REACT_APP_API_URL_HMG}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/candidate/search/my-profile?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

// for edit (data with uuids)
export const GetEmployeeProfileDetails = async () => {
    const queryList = [];
    const language_profile_uuid = GetGlobalLanguageReducer()
        || localStorage.getItem('language_profile_uuid') || '';

    if (language_profile_uuid) queryList.push(`language_profile_uuid=${language_profile_uuid}`);

    const result = await HttpServices.get(
        `${process.env.REACT_APP_API_URL_HMG}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/candidate/search/my-profile-details?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
